import React from 'react';
import actions from './actions';
import reducer from './reducer'
import ls from 'utils/ls';

const AuthContext = React.createContext()

const initialState = {
  loading: true,
  userInfo: null,
  token: null,
  error: null,
  sidebarWidth: '250px',
  mainContainerWidth: null,
  theme: null,
  socket: null,
  forms: null,
  menuKey: null,
  empProfileData: null,
}

const AuthProvider = ({children}) => {
  const [ state, dispatch ] = React.useReducer(reducer, initialState)
  const action = React.useMemo(() => actions(dispatch), [])

  React.useLayoutEffect(() => {
    const bootstrapAsync = async () => {
      try {
        var userInfo = ls.get('userInfo');
        var token = ls.get('token');
        var menuKey = ls.get('mkey');
        dispatch({ 
          type: 'RESTORE_TOKEN', 
          token: token, 
          userInfo: userInfo,
          forms: userInfo?.forms,
        });
        if(menuKey){
          dispatch({ type: 'CHANGE_MENU_KEY', key: menuKey });
        }
      } catch(e) {
      }
    }

    bootstrapAsync();
  }, [])

  return (
    <AuthContext.Provider value={{state, action}}>
      {children}
    </AuthContext.Provider>
  );
}

export {
  AuthProvider,
  AuthContext
}
